import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { isNullOrUndefined, MessageService } from '@sla-ng/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { IValidationError } from '../models/validation/validation-error.model';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class ErrorMessageInterceptor implements HttpInterceptor {
    constructor(private myMessageService: MessageService,
                private myTranslateService: TranslateService) {
    }

    public intercept<T>(request: HttpRequest<T>, next: HttpHandler): Observable<HttpEvent<T>> {
        return next.handle(request).pipe(catchError(err => {
            if (err.status >= 400 && err.status < 500 && !isNullOrUndefined(err.error.violations) && err.error.violations.length > 0) {
                const violations: IValidationError[] = err.error.violations;
                for (const v of violations) {
                    const summary: string = this.myTranslateService.instant('sla-cost-accounting.validation-error.label');
                    const message: string = this.myTranslateService.instant(`${v.key}.label`, v.params);
                    this.myMessageService.error(summary, message, 2);
                }
            }
            return throwError(err);
        }));
    }
}
